// 国际化简体中文表达部分
export default {
  title: {
    map: "看地图",
    marking: "打点",
    plot: "画地块",
    devicePositioning: "设备定位",
    electronicFence: "电子围栏",
    warningDetails: "预警详情",
  },
  common: {
    cancel: "取消",
    confirm: "确认",
    save: "保存",
    delete: "删除",
    close: "关闭",
    satellite: "卫星",
    layer: "标准",
    saving: "保存中...",
    saveSuccess: "保存成功",
    deleteTips: "删除提示",
    deleting: "删除中...",
    deleteSuccess: "删除成功",
    tips: "提示",
    loading: "加载中...",
    modify: "修改",
    revoke: "撤销",
    yes: "是",
    no: "否",
    selectAll: "全选", 
    editing: "编辑中",
    editSuccess: "编辑成功",
    add: "添加",
    uploading: "上传中...",
    uploadFailed: "上传失败",
  },
  form: {
    keywordPlaceholder: "请输入搜索关键词",
    tracking: "设备打点",
    selectDevice: "选择设备",
    park: "当前园区",
    deviceType: "设备类型",
    deviceTypePlaceholder: "请选择设备类型",
    site: "设备站点",
    sitePlaceholder: "请选择设备站点",
    mac: "设备MAC",
    macPlaceholder: "请选择设备MAC",
    latLon: "当前经纬度",
    keyWordDeviceName: "请输入设备名称",
    fenceName: "围栏名称",
    fenceNamePlaceholder: "请输入围栏名称",
    selectSiteConfirm: "已选择{num}个设备站点",
  },
  page: {
    AMap: "高德地图",
    TMap: "腾讯地图",
    BMap: "百度地图",
    devicePositioning: {
      deviceName: "设备名称",
      lon: "设备经度",
      lat: "设备纬度",
      altitude: "海拔高度",
      altitudeUnit: "米",
      btnText: "导航追踪",
    },
    electronicFence: {
      marking: "打点",
    },
    plotManage: {
      plotAddTitle: "新增地块",
      plotEditTitle: "编辑地块",
      plotInfo: "地块基础信息",
      plotName: "地块名称",
      plotArea: "种植面积",
      plotAreaUnit: "亩",
      plotUserName: "负责人",
      plotPhone: "负责人电话",
      plotContractorDeadline: "承包期限",
      plotContractorDeadlineUnit: "年",
      plotIntroduction: "地块介绍",
      plotImage: "地块图片",
      plotNamePlaceholder: "请输入地块名称",
      plotAreaPlaceholder: "请输入种植面积",
      plotUserNamePlaceholder: "请输入负责人",
      plotPhonePlaceholder: "请输入负责人电话",
      plotContractorDeadlinePlaceholder: "请输入承包期限",
      plotIntroductionPlaceholder: "请输入地块介绍",
      cropInfo: "作物基础信息",
      cropName: "作物名称",
      cropIntroduction: "作物介绍",
      cropImage: "作物图片",
      cropNamePlaceholder: "请输入作物名称",
      cropIntroductionPlaceholder: "请输入作物介绍",
      baseInfo: "地块肥力信息",
      baseThickness: "土层厚度",
      baseLevel: "地块等级",
      baseDesc: "土地肥力",
      baseName: "肥力名称",
      baseValue: "数据",
      baseUnit: "单位",
      baseThicknessPlaceholder: "请输入土层厚度",
      baseLevelPlaceholder: "请输入地块等级",
      baseNamePlaceholder: "请输入肥力名称",
      baseValuePlaceholder: "请输入数据",
      baseUnitPlaceholder: "请输入单位",
    },
  },
  warning: {
    noPlot: "暂无该地块信息，请重新选择。",
    latLonError: "获取经纬度信息失败，请重新尝试",
    noSite: "当前类型下暂无站点信息",
    noMac: "当前站点下暂无MAC信息",
    repeatedDotting: "该设备不可重复打点！",
    mapError: "地图实例不存在，请先初始化地图！",
    noPermission: "抱歉，您暂无操作权限!",
    noMobileIrrigationSite: "该移动灌溉站点信息有误，请联系管理员！",
    pleaseDrawFence: "电子围栏至少需要三个点, 请继续绘制！",
    noFenceSite: "电子围栏至少需要绑定一个设备站点！",
    pleaseDrawPlot: "地块至少需要三个点, 请继续绘制！",
    parkRealNameEmpty: "负责人姓名不能为空！",
    parkPhoneEmpty: "负责人电话不能为空！",
    validityPhone: "请输入正确格式的手机号!",
    plotNameEmpty: "地块名称不能为空！",
    plotAreaEmpty: "地块面积不能为空！",
    plotContractorDeadlineEmpty: "承包期限不能为空！",
    plotIntroduceEmpty: "地块介绍不能为空！",
    plotImageEmpty: "请上传一张地块图片！",
    cropNameEmpty: "作物名称不能为空！",
    cropIntroduceEmpty: "作物介绍不能为空！",
    cropImageEmpty: "请上传一张作物图片！",
    plotBaseLevelEmpty: "土地肥力等级不能为空！",
    plotBaseListLess: "请至少添加一条土地肥力信息！",
    plotBaseNameEmpty: "第 {number} 条土地肥力信息 名称 不能为空！",
    plotBaseValueEmpty: "第 {number} 条土地肥力信息 数据 不能为空！",
    plotBaseUnitEmpty: "第 {number} 条土地肥力信息 单位 不能为空！",
  },
  tips: {
    deleteTrackInfo: "您确定删除 {name} 的打点信息么？",
    deviceRefreshPositioning: "您确定刷新 {name} 的定位信息么？",
    openMapSoftware: "您确定打开{software}么？",
    cancelMarking: "您确定取消本次电子围栏绘制么？",
    saveMarking: "是否保存本次电子围栏绘制？",
    confirmFence: "是否确认保存电子围栏？",
    deleteFence: "您确定删除电子围栏({name})？",
    editFence: "您确定修改电子围栏({name})？",
    toLocationPage: "是否前往导航页面?",
    cancelMarkingPlot: "您确定取消本次地块绘制么？",
    saveMarkingPlot: "是否保存本次地块绘制？",
    deletePlot: "您确定删除地块({name})？",
    editPlot: "您确定修改地块({name})？",
  },
  empty: {
    featureEmpty: "功能暂未开放",
  },
};
